// @ts-nocheck
/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';


export const HOST="Specify host"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

export const Thunder =
  (fn: FetchFunction) =>
  <O extends keyof typeof Ops, SCLR extends ScalarDefinition, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<SCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: (Z & ValueTypes[R]) | ValueTypes[R],
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) =>
    fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: graphqlOptions?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (graphqlOptions?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: graphqlOptions.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, SCLR>>;

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  (fn: SubscriptionFunction) =>
  <O extends keyof typeof Ops, SCLR extends ScalarDefinition, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<SCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: (Z & ValueTypes[R]) | ValueTypes[R],
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: graphqlOptions?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], SCLR>;
    if (returnedFunction?.on && graphqlOptions?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, SCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, SCLR>) => {
          if (graphqlOptions?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: graphqlOptions.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: (Z & ValueTypes[R]) | ValueTypes[R],
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <T>(t: T | V) => T;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['ID']: unknown;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = never
export type ScalarCoders = {
	DateTime?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["AuthType"]

export type ValueTypes = {
    ["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ValueTypes["Roles"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ValueTypes["Roles"],
	roleId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: AliasType<{
	users?:ValueTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Roles"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ValueTypes["Permissions"],
	users?:ValueTypes["Users"],
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Configs"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Connection"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	sessionUuid?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ConnectionsPerDay"]: AliasType<{
	day?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DownloadFile"]: AliasType<{
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	buffer?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MyFiles"]: AliasType<{
	eTag?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	ownerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UploadPreSignedUrl"]: AliasType<{
	url?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrackingThematique"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	terminatedAt?:boolean | `@${string}`,
	thematique?:boolean | `@${string}`,
	site?:boolean | `@${string}`,
	currentActivityOrder?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	connection?:ValueTypes["Connection"],
	connectionId?:boolean | `@${string}`,
	trackings?:ValueTypes["Tracking"],
		__typename?: boolean | `@${string}`
}>;
	["Thematique"]:Thematique;
	["Site"]:Site;
	["TrackingThematiqueInfo"]: AliasType<{
	id?:boolean | `@${string}`,
	terminatedAt?:boolean | `@${string}`,
	thematique?:boolean | `@${string}`,
	site?:boolean | `@${string}`,
	currentActivityOrder?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	connection?:ValueTypes["Connection"],
	connectionId?:boolean | `@${string}`,
	trackings?:ValueTypes["TrackingInfo"],
		__typename?: boolean | `@${string}`
}>;
	["TrackingThematiquePagination"]: AliasType<{
	trackings?:ValueTypes["TrackingThematique"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrackingPassedTimeByThematique"]: AliasType<{
	thematique?:boolean | `@${string}`,
	site?:boolean | `@${string}`,
	passedTime?:boolean | `@${string}`,
	viewCount?:boolean | `@${string}`,
	viewCountFinished?:boolean | `@${string}`,
	viewCountLeft?:boolean | `@${string}`,
	questionCount?:boolean | `@${string}`,
	questionCountCorrect?:boolean | `@${string}`,
	questionCountIncorrect?:boolean | `@${string}`,
	responses?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["Response"]: AliasType<{
	activityOrder?:boolean | `@${string}`,
	questionCountCorrect?:boolean | `@${string}`,
	questionCountIncorrect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RushHour"]: AliasType<{
	hour?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SiteRushHour"]: AliasType<{
	site?:boolean | `@${string}`,
	rushHours?:ValueTypes["RushHour"],
		__typename?: boolean | `@${string}`
}>;
	["TrackingsStats"]: AliasType<{
	connectionCount?:boolean | `@${string}`,
	passedTime?:boolean | `@${string}`,
	trackingsByThematique?:ValueTypes["TrackingPassedTimeByThematique"],
	siteRushHour?:ValueTypes["SiteRushHour"],
		__typename?: boolean | `@${string}`
}>;
	["TrackingsCommonStats"]: AliasType<{
	connectionCount?:boolean | `@${string}`,
	passedTime?:boolean | `@${string}`,
	siteRushHour?:ValueTypes["SiteRushHour"],
		__typename?: boolean | `@${string}`
}>;
	["Tracking"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
	activityOrder?:boolean | `@${string}`,
	activityType?:boolean | `@${string}`,
	answers?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	trackingThematique?:ValueTypes["TrackingThematique"],
	trackingThematiqueId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ActivityType"]:ActivityType;
	["TrackingInfo"]: AliasType<{
	id?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
	activityOrder?:boolean | `@${string}`,
	activityType?:boolean | `@${string}`,
	answers?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	trackingThematiqueId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
	getHealthGql?:ValueTypes["Health"],
getRole?: [{	id: number | Variable<any, string>},ValueTypes["Roles"]],
	getRoles?:ValueTypes["Roles"],
getPermission?: [{	id: number | Variable<any, string>},ValueTypes["Permissions"]],
	getPermissions?:ValueTypes["Permissions"],
getConfig?: [{	id: number | Variable<any, string>},ValueTypes["Configs"]],
	getConfigs?:ValueTypes["Configs"],
getMail?: [{	id: number | Variable<any, string>},ValueTypes["Mail"]],
	getMails?:ValueTypes["Mail"],
	sendMail?:boolean | `@${string}`,
loginAsGuest?: [{	email: string | Variable<any, string>},ValueTypes["AuthType"]],
login?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>},ValueTypes["AuthType"]],
uniqueAuthFromSso?: [{	code: string | Variable<any, string>},ValueTypes["UniqueAuth"]],
getUser?: [{	id: number | Variable<any, string>},ValueTypes["Users"]],
	getUsers?:ValueTypes["Users"],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ValueTypes["FindManyUserWithFiltersInput"] | Variable<any, string>},ValueTypes["UserPagination"]],
downloadFile?: [{	eTag: string | Variable<any, string>},ValueTypes["DownloadFile"]],
	getAllMyFiles?:ValueTypes["MyFiles"],
countOfConnectionsPerDay?: [{	findConnectionsPerDayInput: ValueTypes["FindConnectionsPerDayInput"] | Variable<any, string>},ValueTypes["ConnectionsPerDay"]],
	getTrackings?:ValueTypes["Tracking"],
getFilteredTrackingThematiques?: [{	filterTrackingThematiqueInput: ValueTypes["FilterTrackingThematiqueInput"] | Variable<any, string>},ValueTypes["TrackingThematiquePagination"]],
getStats?: [{	filterStatsInput: ValueTypes["FilterStatsInput"] | Variable<any, string>},ValueTypes["TrackingsStats"]],
getCommonStats?: [{	filterStatsInput: ValueTypes["FilterStatsInput"] | Variable<any, string>},ValueTypes["TrackingsCommonStats"]],
		__typename?: boolean | `@${string}`
}>;
	["AuthType"]: AliasType<{		["...on Tokens"] : ValueTypes["Tokens"],
		["...on CustomError"] : ValueTypes["CustomError"]
		__typename?: boolean | `@${string}`
}>;
	["Tokens"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput: string | Variable<any, string>,
	orderBy?: ValueTypes["UserOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["UserFilterByInput"] | undefined | null | Variable<any, string>
};
	["UserOrderByInput"]: {
	email?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	firstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastConnectionAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	role?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined | null | Variable<any, string>
};
	["FindConnectionsPerDayInput"]: {
	startDate: ValueTypes["DateTime"] | Variable<any, string>,
	endDate: ValueTypes["DateTime"] | Variable<any, string>
};
	["FilterTrackingThematiqueInput"]: {
	skip?: number | undefined | null | Variable<any, string>,
	take?: number | undefined | null | Variable<any, string>,
	thematique?: ValueTypes["Thematique"] | undefined | null | Variable<any, string>,
	startDate?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	endDate?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>
};
	["FilterStatsInput"]: {
	startDate?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	endDate?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>
};
	["Mutation"]: AliasType<{
askForResetPassword?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
resetPassword?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
verifyEmail?: [{	email: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
register?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>},ValueTypes["AuthType"]],
askForRegister?: [{	registerUserInput: ValueTypes["RegisterUserInput"] | Variable<any, string>},boolean | `@${string}`],
finishRegister?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
finishRegisterAsGuest?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>},boolean | `@${string}`],
	refresh?:ValueTypes["AuthType"],
	logout?:boolean | `@${string}`,
createUser?: [{	createUserInput: ValueTypes["CreateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
updateUser?: [{	updateUserInput: ValueTypes["UpdateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
deleteUser?: [{	id: number | Variable<any, string>},boolean | `@${string}`],
deleteFile?: [{	fileId: number | Variable<any, string>},boolean | `@${string}`],
uploadPreSignedUrl?: [{	mimeType: string | Variable<any, string>,	fileName: string | Variable<any, string>},ValueTypes["UploadPreSignedUrl"]],
confirmUpload?: [{	id: number | Variable<any, string>,	status: boolean | Variable<any, string>},boolean | `@${string}`],
createConnection?: [{	createConnectionInput: ValueTypes["CreateConnectionInput"] | Variable<any, string>},ValueTypes["Connection"]],
createTracking?: [{	createTrackingInput: ValueTypes["CreateTrackingInput"] | Variable<any, string>},ValueTypes["TrackingInfo"]],
createOrUpdateTrackingThematique?: [{	createTrackingThematiqueInput: ValueTypes["CreateTrackingThematiqueInput"] | Variable<any, string>},ValueTypes["TrackingThematiqueInfo"]],
updateTrackingThematique?: [{	updateTrackingThematiqueInput: ValueTypes["UpdateTrackingThematiqueInput"] | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["RegisterUserInput"]: {
	email: string | Variable<any, string>,
	roleId: number | Variable<any, string>
};
	["CreateUserInput"]: {
	email: string | Variable<any, string>,
	password: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	roleId: number | Variable<any, string>
};
	["UpdateUserInput"]: {
	email?: string | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	roleId?: number | undefined | null | Variable<any, string>,
	id: number | Variable<any, string>
};
	["CreateConnectionInput"]: {
	sessionUuid: string | Variable<any, string>
};
	["CreateTrackingInput"]: {
	trackingThematiqueId: number | Variable<any, string>,
	isCorrect: boolean | Variable<any, string>,
	activityOrder: number | Variable<any, string>,
	activityType: ValueTypes["ActivityType"] | Variable<any, string>,
	answers: Array<string> | Variable<any, string>,
	time: number | Variable<any, string>
};
	["CreateTrackingThematiqueInput"]: {
	sessionUuid: string | Variable<any, string>,
	connectionId?: number | undefined | null | Variable<any, string>,
	trackingThematiqueId?: number | undefined | null | Variable<any, string>,
	site: ValueTypes["Site"] | Variable<any, string>,
	thematique: ValueTypes["Thematique"] | Variable<any, string>,
	currentActivityOrder: number | Variable<any, string>
};
	["UpdateTrackingThematiqueInput"]: {
	id: number | Variable<any, string>,
	time?: number | undefined | null | Variable<any, string>,
	currentActivityOrder?: number | undefined | null | Variable<any, string>,
	terminatedAt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>
}
  }

export type ResolverInputTypes = {
    ["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ResolverInputTypes["Roles"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ResolverInputTypes["Roles"],
	roleId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: AliasType<{
	users?:ResolverInputTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Roles"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ResolverInputTypes["Permissions"],
	users?:ResolverInputTypes["Users"],
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Configs"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Connection"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	sessionUuid?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ConnectionsPerDay"]: AliasType<{
	day?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DownloadFile"]: AliasType<{
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	buffer?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MyFiles"]: AliasType<{
	eTag?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	ownerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UploadPreSignedUrl"]: AliasType<{
	url?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrackingThematique"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	terminatedAt?:boolean | `@${string}`,
	thematique?:boolean | `@${string}`,
	site?:boolean | `@${string}`,
	currentActivityOrder?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	connection?:ResolverInputTypes["Connection"],
	connectionId?:boolean | `@${string}`,
	trackings?:ResolverInputTypes["Tracking"],
		__typename?: boolean | `@${string}`
}>;
	["Thematique"]:Thematique;
	["Site"]:Site;
	["TrackingThematiqueInfo"]: AliasType<{
	id?:boolean | `@${string}`,
	terminatedAt?:boolean | `@${string}`,
	thematique?:boolean | `@${string}`,
	site?:boolean | `@${string}`,
	currentActivityOrder?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	connection?:ResolverInputTypes["Connection"],
	connectionId?:boolean | `@${string}`,
	trackings?:ResolverInputTypes["TrackingInfo"],
		__typename?: boolean | `@${string}`
}>;
	["TrackingThematiquePagination"]: AliasType<{
	trackings?:ResolverInputTypes["TrackingThematique"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrackingPassedTimeByThematique"]: AliasType<{
	thematique?:boolean | `@${string}`,
	site?:boolean | `@${string}`,
	passedTime?:boolean | `@${string}`,
	viewCount?:boolean | `@${string}`,
	viewCountFinished?:boolean | `@${string}`,
	viewCountLeft?:boolean | `@${string}`,
	questionCount?:boolean | `@${string}`,
	questionCountCorrect?:boolean | `@${string}`,
	questionCountIncorrect?:boolean | `@${string}`,
	responses?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["Response"]: AliasType<{
	activityOrder?:boolean | `@${string}`,
	questionCountCorrect?:boolean | `@${string}`,
	questionCountIncorrect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RushHour"]: AliasType<{
	hour?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SiteRushHour"]: AliasType<{
	site?:boolean | `@${string}`,
	rushHours?:ResolverInputTypes["RushHour"],
		__typename?: boolean | `@${string}`
}>;
	["TrackingsStats"]: AliasType<{
	connectionCount?:boolean | `@${string}`,
	passedTime?:boolean | `@${string}`,
	trackingsByThematique?:ResolverInputTypes["TrackingPassedTimeByThematique"],
	siteRushHour?:ResolverInputTypes["SiteRushHour"],
		__typename?: boolean | `@${string}`
}>;
	["TrackingsCommonStats"]: AliasType<{
	connectionCount?:boolean | `@${string}`,
	passedTime?:boolean | `@${string}`,
	siteRushHour?:ResolverInputTypes["SiteRushHour"],
		__typename?: boolean | `@${string}`
}>;
	["Tracking"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
	activityOrder?:boolean | `@${string}`,
	activityType?:boolean | `@${string}`,
	answers?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	trackingThematique?:ResolverInputTypes["TrackingThematique"],
	trackingThematiqueId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ActivityType"]:ActivityType;
	["TrackingInfo"]: AliasType<{
	id?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
	activityOrder?:boolean | `@${string}`,
	activityType?:boolean | `@${string}`,
	answers?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	trackingThematiqueId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
	getHealthGql?:ResolverInputTypes["Health"],
getRole?: [{	id: number},ResolverInputTypes["Roles"]],
	getRoles?:ResolverInputTypes["Roles"],
getPermission?: [{	id: number},ResolverInputTypes["Permissions"]],
	getPermissions?:ResolverInputTypes["Permissions"],
getConfig?: [{	id: number},ResolverInputTypes["Configs"]],
	getConfigs?:ResolverInputTypes["Configs"],
getMail?: [{	id: number},ResolverInputTypes["Mail"]],
	getMails?:ResolverInputTypes["Mail"],
	sendMail?:boolean | `@${string}`,
loginAsGuest?: [{	email: string},ResolverInputTypes["AuthType"]],
login?: [{	email: string,	password: string},ResolverInputTypes["AuthType"]],
uniqueAuthFromSso?: [{	code: string},ResolverInputTypes["UniqueAuth"]],
getUser?: [{	id: number},ResolverInputTypes["Users"]],
	getUsers?:ResolverInputTypes["Users"],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ResolverInputTypes["FindManyUserWithFiltersInput"]},ResolverInputTypes["UserPagination"]],
downloadFile?: [{	eTag: string},ResolverInputTypes["DownloadFile"]],
	getAllMyFiles?:ResolverInputTypes["MyFiles"],
countOfConnectionsPerDay?: [{	findConnectionsPerDayInput: ResolverInputTypes["FindConnectionsPerDayInput"]},ResolverInputTypes["ConnectionsPerDay"]],
	getTrackings?:ResolverInputTypes["Tracking"],
getFilteredTrackingThematiques?: [{	filterTrackingThematiqueInput: ResolverInputTypes["FilterTrackingThematiqueInput"]},ResolverInputTypes["TrackingThematiquePagination"]],
getStats?: [{	filterStatsInput: ResolverInputTypes["FilterStatsInput"]},ResolverInputTypes["TrackingsStats"]],
getCommonStats?: [{	filterStatsInput: ResolverInputTypes["FilterStatsInput"]},ResolverInputTypes["TrackingsCommonStats"]],
		__typename?: boolean | `@${string}`
}>;
	["AuthType"]: AliasType<{
	Tokens?:ResolverInputTypes["Tokens"],
	CustomError?:ResolverInputTypes["CustomError"],
		__typename?: boolean | `@${string}`
}>;
	["Tokens"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ResolverInputTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	firstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	role?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined | null
};
	["FindConnectionsPerDayInput"]: {
	startDate: ResolverInputTypes["DateTime"],
	endDate: ResolverInputTypes["DateTime"]
};
	["FilterTrackingThematiqueInput"]: {
	skip?: number | undefined | null,
	take?: number | undefined | null,
	thematique?: ResolverInputTypes["Thematique"] | undefined | null,
	startDate?: ResolverInputTypes["DateTime"] | undefined | null,
	endDate?: ResolverInputTypes["DateTime"] | undefined | null
};
	["FilterStatsInput"]: {
	startDate?: ResolverInputTypes["DateTime"] | undefined | null,
	endDate?: ResolverInputTypes["DateTime"] | undefined | null
};
	["Mutation"]: AliasType<{
askForResetPassword?: [{	email: string},boolean | `@${string}`],
resetPassword?: [{	email: string,	password: string,	token: string},boolean | `@${string}`],
verifyEmail?: [{	email: string,	token: string},boolean | `@${string}`],
register?: [{	email: string,	password: string,	firstName: string,	lastName: string},ResolverInputTypes["AuthType"]],
askForRegister?: [{	registerUserInput: ResolverInputTypes["RegisterUserInput"]},boolean | `@${string}`],
finishRegister?: [{	email: string,	password: string,	firstName: string,	lastName: string,	token: string},boolean | `@${string}`],
finishRegisterAsGuest?: [{	email: string,	password: string,	firstName: string,	lastName: string},boolean | `@${string}`],
	refresh?:ResolverInputTypes["AuthType"],
	logout?:boolean | `@${string}`,
createUser?: [{	createUserInput: ResolverInputTypes["CreateUserInput"]},ResolverInputTypes["Users"]],
updateUser?: [{	updateUserInput: ResolverInputTypes["UpdateUserInput"]},ResolverInputTypes["Users"]],
deleteUser?: [{	id: number},boolean | `@${string}`],
deleteFile?: [{	fileId: number},boolean | `@${string}`],
uploadPreSignedUrl?: [{	mimeType: string,	fileName: string},ResolverInputTypes["UploadPreSignedUrl"]],
confirmUpload?: [{	id: number,	status: boolean},boolean | `@${string}`],
createConnection?: [{	createConnectionInput: ResolverInputTypes["CreateConnectionInput"]},ResolverInputTypes["Connection"]],
createTracking?: [{	createTrackingInput: ResolverInputTypes["CreateTrackingInput"]},ResolverInputTypes["TrackingInfo"]],
createOrUpdateTrackingThematique?: [{	createTrackingThematiqueInput: ResolverInputTypes["CreateTrackingThematiqueInput"]},ResolverInputTypes["TrackingThematiqueInfo"]],
updateTrackingThematique?: [{	updateTrackingThematiqueInput: ResolverInputTypes["UpdateTrackingThematiqueInput"]},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["RegisterUserInput"]: {
	email: string,
	roleId: number
};
	["CreateUserInput"]: {
	email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: number
};
	["UpdateUserInput"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: number | undefined | null,
	id: number
};
	["CreateConnectionInput"]: {
	sessionUuid: string
};
	["CreateTrackingInput"]: {
	trackingThematiqueId: number,
	isCorrect: boolean,
	activityOrder: number,
	activityType: ResolverInputTypes["ActivityType"],
	answers: Array<string>,
	time: number
};
	["CreateTrackingThematiqueInput"]: {
	sessionUuid: string,
	connectionId?: number | undefined | null,
	trackingThematiqueId?: number | undefined | null,
	site: ResolverInputTypes["Site"],
	thematique: ResolverInputTypes["Thematique"],
	currentActivityOrder: number
};
	["UpdateTrackingThematiqueInput"]: {
	id: number,
	time?: number | undefined | null,
	currentActivityOrder?: number | undefined | null,
	terminatedAt?: ResolverInputTypes["DateTime"] | undefined | null
};
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
		__typename?: boolean | `@${string}`
}>
  }

export type ModelTypes = {
    ["Health"]: {
		env: string,
	time: string,
	status: string
};
	["Permissions"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	roles: Array<ModelTypes["Roles"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:any;
	["Users"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	status: ModelTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined,
	passwordResetExpiryDate?: ModelTypes["DateTime"] | undefined,
	activateAccountToken?: string | undefined,
	activateAccountExpiryDate?: ModelTypes["DateTime"] | undefined,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined,
	verifyEmailExpiryDate?: ModelTypes["DateTime"] | undefined,
	firstName: string,
	lastName: string,
	refreshToken?: string | undefined,
	role: ModelTypes["Roles"],
	roleId: number
};
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: {
		users: Array<ModelTypes["Users"] | undefined>,
	total: number
};
	["Roles"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	permissions: Array<ModelTypes["Permissions"] | undefined>,
	users: Array<ModelTypes["Users"] | undefined>
};
	["UniqueAuth"]: {
		access_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string
};
	["Configs"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	key: string,
	value: string
};
	["Connection"]: {
		id: number,
	createdAt: ModelTypes["DateTime"],
	sessionUuid: string
};
	["ConnectionsPerDay"]: {
		day: ModelTypes["DateTime"],
	count: number
};
	["DownloadFile"]: {
		fileName: string,
	fileMimeType: string,
	buffer: string
};
	["MyFiles"]: {
		eTag: string,
	location: string,
	fileName: string,
	fileMimeType: string,
	createdAt: ModelTypes["DateTime"],
	ownerId: number
};
	["UploadPreSignedUrl"]: {
		url: string,
	id: number
};
	["Mail"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["TrackingThematique"]: {
		id: number,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	terminatedAt?: ModelTypes["DateTime"] | undefined,
	thematique: ModelTypes["Thematique"],
	site: ModelTypes["Site"],
	currentActivityOrder?: number | undefined,
	time?: number | undefined,
	connection: ModelTypes["Connection"],
	connectionId: number,
	trackings: Array<ModelTypes["Tracking"]>
};
	["Thematique"]:Thematique;
	["Site"]:Site;
	["TrackingThematiqueInfo"]: {
		id: number,
	terminatedAt?: ModelTypes["DateTime"] | undefined,
	thematique: ModelTypes["Thematique"],
	site: ModelTypes["Site"],
	currentActivityOrder?: number | undefined,
	time?: number | undefined,
	connection: ModelTypes["Connection"],
	connectionId: number,
	trackings: Array<ModelTypes["TrackingInfo"]>
};
	["TrackingThematiquePagination"]: {
		trackings: Array<ModelTypes["TrackingThematique"] | undefined>,
	total: number
};
	["TrackingPassedTimeByThematique"]: {
		thematique: ModelTypes["Thematique"],
	site: ModelTypes["Site"],
	passedTime: number,
	viewCount: number,
	viewCountFinished: number,
	viewCountLeft: number,
	questionCount: number,
	questionCountCorrect: number,
	questionCountIncorrect: number,
	responses: Array<ModelTypes["Response"]>
};
	["Response"]: {
		activityOrder: number,
	questionCountCorrect: number,
	questionCountIncorrect: number
};
	["RushHour"]: {
		hour: number,
	count: number
};
	["SiteRushHour"]: {
		site: string,
	rushHours: Array<ModelTypes["RushHour"] | undefined>
};
	["TrackingsStats"]: {
		connectionCount: number,
	passedTime: number,
	trackingsByThematique: Array<ModelTypes["TrackingPassedTimeByThematique"] | undefined>,
	siteRushHour: Array<ModelTypes["SiteRushHour"] | undefined>
};
	["TrackingsCommonStats"]: {
		connectionCount: number,
	passedTime: number,
	siteRushHour: Array<ModelTypes["SiteRushHour"] | undefined>
};
	["Tracking"]: {
		id: number,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	isCorrect: boolean,
	activityOrder: number,
	activityType: ModelTypes["ActivityType"],
	answers: Array<string>,
	time: number,
	trackingThematique: ModelTypes["TrackingThematique"],
	trackingThematiqueId: number
};
	["ActivityType"]:ActivityType;
	["TrackingInfo"]: {
		id: number,
	isCorrect: boolean,
	activityOrder: number,
	activityType: ModelTypes["ActivityType"],
	answers: Array<string>,
	time: number,
	trackingThematiqueId: number
};
	["Query"]: {
		getHealthGql: ModelTypes["Health"],
	getRole: ModelTypes["Roles"],
	getRoles: Array<ModelTypes["Roles"]>,
	getPermission: ModelTypes["Permissions"],
	getPermissions: Array<ModelTypes["Permissions"]>,
	getConfig: ModelTypes["Configs"],
	getConfigs: Array<ModelTypes["Configs"]>,
	getMail: ModelTypes["Mail"],
	getMails: Array<ModelTypes["Mail"]>,
	sendMail: boolean,
	loginAsGuest: ModelTypes["AuthType"],
	login: ModelTypes["AuthType"],
	uniqueAuthFromSso: ModelTypes["UniqueAuth"],
	getUser: ModelTypes["Users"],
	getUsers: Array<ModelTypes["Users"]>,
	getFilteredUsers: ModelTypes["UserPagination"],
	downloadFile: ModelTypes["DownloadFile"],
	getAllMyFiles: Array<ModelTypes["MyFiles"]>,
	countOfConnectionsPerDay: Array<ModelTypes["ConnectionsPerDay"]>,
	getTrackings: Array<ModelTypes["Tracking"]>,
	getFilteredTrackingThematiques: ModelTypes["TrackingThematiquePagination"],
	getStats: ModelTypes["TrackingsStats"],
	getCommonStats: ModelTypes["TrackingsCommonStats"]
};
	["AuthType"]:ModelTypes["Tokens"] | ModelTypes["CustomError"];
	["Tokens"]: {
		access_token: string,
	refresh_token: string
};
	["CustomError"]: {
		error: ModelTypes["EError"],
	message: string
};
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ModelTypes["UserOrderByInput"] | undefined,
	filterBy?: ModelTypes["UserFilterByInput"] | undefined
};
	["UserOrderByInput"]: {
	email?: ModelTypes["OrderByEnum"] | undefined,
	firstName?: ModelTypes["OrderByEnum"] | undefined,
	lastName?: ModelTypes["OrderByEnum"] | undefined,
	lastConnectionAt?: ModelTypes["OrderByEnum"] | undefined,
	role?: ModelTypes["OrderByEnum"] | undefined
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined
};
	["FindConnectionsPerDayInput"]: {
	startDate: ModelTypes["DateTime"],
	endDate: ModelTypes["DateTime"]
};
	["FilterTrackingThematiqueInput"]: {
	skip?: number | undefined,
	take?: number | undefined,
	thematique?: ModelTypes["Thematique"] | undefined,
	startDate?: ModelTypes["DateTime"] | undefined,
	endDate?: ModelTypes["DateTime"] | undefined
};
	["FilterStatsInput"]: {
	startDate?: ModelTypes["DateTime"] | undefined,
	endDate?: ModelTypes["DateTime"] | undefined
};
	["Mutation"]: {
		askForResetPassword: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	register: ModelTypes["AuthType"],
	askForRegister: boolean,
	finishRegister: boolean,
	finishRegisterAsGuest: boolean,
	refresh: ModelTypes["AuthType"],
	logout: boolean,
	createUser: ModelTypes["Users"],
	updateUser: ModelTypes["Users"],
	deleteUser: boolean,
	deleteFile: boolean,
	uploadPreSignedUrl: ModelTypes["UploadPreSignedUrl"],
	confirmUpload: boolean,
	createConnection: ModelTypes["Connection"],
	createTracking: ModelTypes["TrackingInfo"],
	createOrUpdateTrackingThematique: ModelTypes["TrackingThematiqueInfo"],
	updateTrackingThematique: boolean
};
	["RegisterUserInput"]: {
	email: string,
	roleId: number
};
	["CreateUserInput"]: {
	email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: number
};
	["UpdateUserInput"]: {
	email?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	roleId?: number | undefined,
	id: number
};
	["CreateConnectionInput"]: {
	sessionUuid: string
};
	["CreateTrackingInput"]: {
	trackingThematiqueId: number,
	isCorrect: boolean,
	activityOrder: number,
	activityType: ModelTypes["ActivityType"],
	answers: Array<string>,
	time: number
};
	["CreateTrackingThematiqueInput"]: {
	sessionUuid: string,
	connectionId?: number | undefined,
	trackingThematiqueId?: number | undefined,
	site: ModelTypes["Site"],
	thematique: ModelTypes["Thematique"],
	currentActivityOrder: number
};
	["UpdateTrackingThematiqueInput"]: {
	id: number,
	time?: number | undefined,
	currentActivityOrder?: number | undefined,
	terminatedAt?: ModelTypes["DateTime"] | undefined
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined,
	mutation?: ModelTypes["Mutation"] | undefined
}
    }

export type GraphQLTypes = {
    // ------------------------------------------------------;
	// THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY);
	// ------------------------------------------------------;
	["Health"]: {
	__typename: "Health",
	env: string,
	time: string,
	status: string
};
	["Permissions"]: {
	__typename: "Permissions",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	roles: Array<GraphQLTypes["Roles"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]: "scalar" & { name: "DateTime" };
	["Users"]: {
	__typename: "Users",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	status: GraphQLTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined,
	passwordResetExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	activateAccountToken?: string | undefined,
	activateAccountExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined,
	verifyEmailExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	firstName: string,
	lastName: string,
	refreshToken?: string | undefined,
	role: GraphQLTypes["Roles"],
	roleId: number
};
	["AccountStatus"]: AccountStatus;
	["UserPagination"]: {
	__typename: "UserPagination",
	users: Array<GraphQLTypes["Users"] | undefined>,
	total: number
};
	["Roles"]: {
	__typename: "Roles",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	permissions: Array<GraphQLTypes["Permissions"] | undefined>,
	users: Array<GraphQLTypes["Users"] | undefined>
};
	["UniqueAuth"]: {
	__typename: "UniqueAuth",
	access_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string
};
	["Configs"]: {
	__typename: "Configs",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	key: string,
	value: string
};
	["Connection"]: {
	__typename: "Connection",
	id: number,
	createdAt: GraphQLTypes["DateTime"],
	sessionUuid: string
};
	["ConnectionsPerDay"]: {
	__typename: "ConnectionsPerDay",
	day: GraphQLTypes["DateTime"],
	count: number
};
	["DownloadFile"]: {
	__typename: "DownloadFile",
	fileName: string,
	fileMimeType: string,
	buffer: string
};
	["MyFiles"]: {
	__typename: "MyFiles",
	eTag: string,
	location: string,
	fileName: string,
	fileMimeType: string,
	createdAt: GraphQLTypes["DateTime"],
	ownerId: number
};
	["UploadPreSignedUrl"]: {
	__typename: "UploadPreSignedUrl",
	url: string,
	id: number
};
	["Mail"]: {
	__typename: "Mail",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["TrackingThematique"]: {
	__typename: "TrackingThematique",
	id: number,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	terminatedAt?: GraphQLTypes["DateTime"] | undefined,
	thematique: GraphQLTypes["Thematique"],
	site: GraphQLTypes["Site"],
	currentActivityOrder?: number | undefined,
	time?: number | undefined,
	connection: GraphQLTypes["Connection"],
	connectionId: number,
	trackings: Array<GraphQLTypes["Tracking"]>
};
	["Thematique"]: Thematique;
	["Site"]: Site;
	["TrackingThematiqueInfo"]: {
	__typename: "TrackingThematiqueInfo",
	id: number,
	terminatedAt?: GraphQLTypes["DateTime"] | undefined,
	thematique: GraphQLTypes["Thematique"],
	site: GraphQLTypes["Site"],
	currentActivityOrder?: number | undefined,
	time?: number | undefined,
	connection: GraphQLTypes["Connection"],
	connectionId: number,
	trackings: Array<GraphQLTypes["TrackingInfo"]>
};
	["TrackingThematiquePagination"]: {
	__typename: "TrackingThematiquePagination",
	trackings: Array<GraphQLTypes["TrackingThematique"] | undefined>,
	total: number
};
	["TrackingPassedTimeByThematique"]: {
	__typename: "TrackingPassedTimeByThematique",
	thematique: GraphQLTypes["Thematique"],
	site: GraphQLTypes["Site"],
	passedTime: number,
	viewCount: number,
	viewCountFinished: number,
	viewCountLeft: number,
	questionCount: number,
	questionCountCorrect: number,
	questionCountIncorrect: number,
	responses: Array<GraphQLTypes["Response"]>
};
	["Response"]: {
	__typename: "Response",
	activityOrder: number,
	questionCountCorrect: number,
	questionCountIncorrect: number
};
	["RushHour"]: {
	__typename: "RushHour",
	hour: number,
	count: number
};
	["SiteRushHour"]: {
	__typename: "SiteRushHour",
	site: string,
	rushHours: Array<GraphQLTypes["RushHour"] | undefined>
};
	["TrackingsStats"]: {
	__typename: "TrackingsStats",
	connectionCount: number,
	passedTime: number,
	trackingsByThematique: Array<GraphQLTypes["TrackingPassedTimeByThematique"] | undefined>,
	siteRushHour: Array<GraphQLTypes["SiteRushHour"] | undefined>
};
	["TrackingsCommonStats"]: {
	__typename: "TrackingsCommonStats",
	connectionCount: number,
	passedTime: number,
	siteRushHour: Array<GraphQLTypes["SiteRushHour"] | undefined>
};
	["Tracking"]: {
	__typename: "Tracking",
	id: number,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	isCorrect: boolean,
	activityOrder: number,
	activityType: GraphQLTypes["ActivityType"],
	answers: Array<string>,
	time: number,
	trackingThematique: GraphQLTypes["TrackingThematique"],
	trackingThematiqueId: number
};
	["ActivityType"]: ActivityType;
	["TrackingInfo"]: {
	__typename: "TrackingInfo",
	id: number,
	isCorrect: boolean,
	activityOrder: number,
	activityType: GraphQLTypes["ActivityType"],
	answers: Array<string>,
	time: number,
	trackingThematiqueId: number
};
	["Query"]: {
	__typename: "Query",
	getHealthGql: GraphQLTypes["Health"],
	getRole: GraphQLTypes["Roles"],
	getRoles: Array<GraphQLTypes["Roles"]>,
	getPermission: GraphQLTypes["Permissions"],
	getPermissions: Array<GraphQLTypes["Permissions"]>,
	getConfig: GraphQLTypes["Configs"],
	getConfigs: Array<GraphQLTypes["Configs"]>,
	getMail: GraphQLTypes["Mail"],
	getMails: Array<GraphQLTypes["Mail"]>,
	sendMail: boolean,
	loginAsGuest: GraphQLTypes["AuthType"],
	login: GraphQLTypes["AuthType"],
	uniqueAuthFromSso: GraphQLTypes["UniqueAuth"],
	getUser: GraphQLTypes["Users"],
	getUsers: Array<GraphQLTypes["Users"]>,
	getFilteredUsers: GraphQLTypes["UserPagination"],
	downloadFile: GraphQLTypes["DownloadFile"],
	getAllMyFiles: Array<GraphQLTypes["MyFiles"]>,
	countOfConnectionsPerDay: Array<GraphQLTypes["ConnectionsPerDay"]>,
	getTrackings: Array<GraphQLTypes["Tracking"]>,
	getFilteredTrackingThematiques: GraphQLTypes["TrackingThematiquePagination"],
	getStats: GraphQLTypes["TrackingsStats"],
	getCommonStats: GraphQLTypes["TrackingsCommonStats"]
};
	["AuthType"]:{
        	__typename:"Tokens" | "CustomError"
        	['...on Tokens']: '__union' & GraphQLTypes["Tokens"];
	['...on CustomError']: '__union' & GraphQLTypes["CustomError"];
};
	["Tokens"]: {
	__typename: "Tokens",
	access_token: string,
	refresh_token: string
};
	["CustomError"]: {
	__typename: "CustomError",
	error: GraphQLTypes["EError"],
	message: string
};
	["EError"]: EError;
	["FindManyUserWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput: string,
	orderBy?: GraphQLTypes["UserOrderByInput"] | undefined,
	filterBy?: GraphQLTypes["UserFilterByInput"] | undefined
};
	["UserOrderByInput"]: {
		email?: GraphQLTypes["OrderByEnum"] | undefined,
	firstName?: GraphQLTypes["OrderByEnum"] | undefined,
	lastName?: GraphQLTypes["OrderByEnum"] | undefined,
	lastConnectionAt?: GraphQLTypes["OrderByEnum"] | undefined,
	role?: GraphQLTypes["OrderByEnum"] | undefined
};
	["OrderByEnum"]: OrderByEnum;
	["UserFilterByInput"]: {
		role?: Array<number> | undefined
};
	["FindConnectionsPerDayInput"]: {
		startDate: GraphQLTypes["DateTime"],
	endDate: GraphQLTypes["DateTime"]
};
	["FilterTrackingThematiqueInput"]: {
		skip?: number | undefined,
	take?: number | undefined,
	thematique?: GraphQLTypes["Thematique"] | undefined,
	startDate?: GraphQLTypes["DateTime"] | undefined,
	endDate?: GraphQLTypes["DateTime"] | undefined
};
	["FilterStatsInput"]: {
		startDate?: GraphQLTypes["DateTime"] | undefined,
	endDate?: GraphQLTypes["DateTime"] | undefined
};
	["Mutation"]: {
	__typename: "Mutation",
	askForResetPassword: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	register: GraphQLTypes["AuthType"],
	askForRegister: boolean,
	finishRegister: boolean,
	finishRegisterAsGuest: boolean,
	refresh: GraphQLTypes["AuthType"],
	logout: boolean,
	createUser: GraphQLTypes["Users"],
	updateUser: GraphQLTypes["Users"],
	deleteUser: boolean,
	deleteFile: boolean,
	uploadPreSignedUrl: GraphQLTypes["UploadPreSignedUrl"],
	confirmUpload: boolean,
	createConnection: GraphQLTypes["Connection"],
	createTracking: GraphQLTypes["TrackingInfo"],
	createOrUpdateTrackingThematique: GraphQLTypes["TrackingThematiqueInfo"],
	updateTrackingThematique: boolean
};
	["RegisterUserInput"]: {
		email: string,
	roleId: number
};
	["CreateUserInput"]: {
		email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: number
};
	["UpdateUserInput"]: {
		email?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	roleId?: number | undefined,
	id: number
};
	["CreateConnectionInput"]: {
		sessionUuid: string
};
	["CreateTrackingInput"]: {
		trackingThematiqueId: number,
	isCorrect: boolean,
	activityOrder: number,
	activityType: GraphQLTypes["ActivityType"],
	answers: Array<string>,
	time: number
};
	["CreateTrackingThematiqueInput"]: {
		sessionUuid: string,
	connectionId?: number | undefined,
	trackingThematiqueId?: number | undefined,
	site: GraphQLTypes["Site"],
	thematique: GraphQLTypes["Thematique"],
	currentActivityOrder: number
};
	["UpdateTrackingThematiqueInput"]: {
		id: number,
	time?: number | undefined,
	currentActivityOrder?: number | undefined,
	terminatedAt?: GraphQLTypes["DateTime"] | undefined
}
    }
export const enum AccountStatus {
	PENDING_ACTIVATION = "PENDING_ACTIVATION",
	ENABLED = "ENABLED",
	DISABLED = "DISABLED"
}
export const enum Thematique {
	CVC = "CVC",
	ECLAIRAGES = "ECLAIRAGES",
	SORBONNES = "SORBONNES",
	STORES = "STORES",
	CONTROLS = "CONTROLS",
	ASCENSEURS = "ASCENSEURS"
}
export const enum Site {
	IDEEV = "IDEEV",
	HM = "HM"
}
export const enum ActivityType {
	DIALOG = "DIALOG",
	DIALOG_IMAGE = "DIALOG_IMAGE",
	CLICK_IMAGE = "CLICK_IMAGE",
	CLICK_OBJECT = "CLICK_OBJECT",
	FRISE = "FRISE",
	DRAG_DROP = "DRAG_DROP",
	QCU = "QCU",
	QCM = "QCM",
	RECAP = "RECAP"
}
export const enum EError {
	AUTH = "AUTH",
	CONNECTION = "CONNECTION",
	TRACKING = "TRACKING",
	TRACKING_THEMATIQUE = "TRACKING_THEMATIQUE"
}
export const enum OrderByEnum {
	ASC = "ASC",
	DESC = "DESC"
}

type ZEUS_VARIABLES = {
	["DateTime"]: ValueTypes["DateTime"];
	["AccountStatus"]: ValueTypes["AccountStatus"];
	["Thematique"]: ValueTypes["Thematique"];
	["Site"]: ValueTypes["Site"];
	["ActivityType"]: ValueTypes["ActivityType"];
	["EError"]: ValueTypes["EError"];
	["FindManyUserWithFiltersInput"]: ValueTypes["FindManyUserWithFiltersInput"];
	["UserOrderByInput"]: ValueTypes["UserOrderByInput"];
	["OrderByEnum"]: ValueTypes["OrderByEnum"];
	["UserFilterByInput"]: ValueTypes["UserFilterByInput"];
	["FindConnectionsPerDayInput"]: ValueTypes["FindConnectionsPerDayInput"];
	["FilterTrackingThematiqueInput"]: ValueTypes["FilterTrackingThematiqueInput"];
	["FilterStatsInput"]: ValueTypes["FilterStatsInput"];
	["RegisterUserInput"]: ValueTypes["RegisterUserInput"];
	["CreateUserInput"]: ValueTypes["CreateUserInput"];
	["UpdateUserInput"]: ValueTypes["UpdateUserInput"];
	["CreateConnectionInput"]: ValueTypes["CreateConnectionInput"];
	["CreateTrackingInput"]: ValueTypes["CreateTrackingInput"];
	["CreateTrackingThematiqueInput"]: ValueTypes["CreateTrackingThematiqueInput"];
	["UpdateTrackingThematiqueInput"]: ValueTypes["UpdateTrackingThematiqueInput"];
}